module.exports = __webpack_public_path__ + "static/media/cq_ultima_settimana_option.ebd3962f.svg";